export const SESSION_EXPIRED_ERROR_CODE = 'SESSION_EXPIRED';
export const SESSION_EXPIRED_ERROR_MESSAGE = 'Session expired';
export const FAILED_TO_FETCH_ERROR_MESSAGE = 'Failed to fetch';

export const isFailedToFetchError = error =>
    error?.message?.includes(FAILED_TO_FETCH_ERROR_MESSAGE);

export const createSessionExpiredError = () => {
    const error = new Error(SESSION_EXPIRED_ERROR_MESSAGE);
    error.code = SESSION_EXPIRED_ERROR_CODE;
    return error;
};

export const createRejectingUnauthorizedHandler =
    ({ onNotify, onLogout } = {}) =>
    async (error, request) => {
        const logoutPromise = onLogout ? onLogout() : null;

        if (onNotify) {
            onNotify(error, request);
        }

        if (logoutPromise) {
            await logoutPromise;
        }

        throw error;
    };

export const createExpiredSessionMiddleware =
    ({ hasSessionExpired, onLogout }) =>
    () =>
    next =>
    async (url, opts) => {
        if (opts.context?.ssoBootstrap !== true && hasSessionExpired()) {
            await onLogout();
            throw createSessionExpiredError();
        }

        return next(url, opts);
    };
